import Folder from './Folder.svg';
import File from './File.svg';
import ArrowRight from './ArrowRight.svg';
import ArrowDown from './ArrowDown.svg';

export const FolderStructureIcons = {
    Folder, File, ArrowRight, ArrowDown
}